// @flow
import React from "react";
import t from "common/i18n";
import MenuButton from "root/components/MenuButton/MenuButton";
import SvgIcon from "../SvgIcon";
import SVG_ICONS from "~/assets/icons/icons";

type propsType = {
    selectedCount: number,
    onClearClick: ?Function
};

const SelectedCounter = (props: propsType) => <div className="SelectedCounter flex flex-column items-end mr4" data-test="selected-counter">
	<div className="c-action mb2 flex flex-row items-center justify-between lh-solid">
		<div className="flex justify-between items-center mr2" data-test="selection-counter-text">
			<SvgIcon size="sm" path={SVG_ICONS.CHECKED} className="fill-action"/>
			{props.selectedCount}
		</div>
		{t("selection_counter.selected")}
	</div>
	<div className="flex flex-row items-center c-menu-icons pointer" data-test="counter-clear-button"
		onClick={props.onClearClick}>
		<MenuButton iconSize="xs" icon={SVG_ICONS.CANCEL} text={t("actions.clear_all")} fontSize={10}/>
	</div>
</div>;

export default SelectedCounter;
